<template>
  <div @click.stop="clickCell()"  class="cell-click-div" :class="{'cell-null': (editConfigure.viewNull) && !(editConfigure.field in rowData)}" :style="{backgroundColor: fillBackColor}">
    <el-input
      ref = "inputContent"
      v-if="editable && editConfigure.editType == 'input'"
      v-focus
      @blur="onInputBlur"
      v-model="inputValue"
      size="mini"
      class="editRemarkInput"
      @keyup.up.native="cursorUp"
      @keyup.enter.native="cursorEntry"
      @keyup.down.native="cursorDown"
    ></el-input>


    <el-input-number
      ref = "numberContent"
      v-if="editable && editConfigure.editType == 'number'"
      v-focus
      v-model="numberValue"
      @blur="onNumberBlur"
      controls-position="right"
      @change="onNumberChange"
      class="editNumberInput"
      @keyup.up.native="cursorUp"
      @keyup.enter.native="cursorEntry"
      @keyup.down.native="cursorDown"
    ></el-input-number>

    <el-date-picker
      ref = "inputContent"
      v-else-if="editable && editConfigure.editType == 'date'"
      v-model="dateValue"
      v-focus
      @blur="onDateBlur"
      type="date"
      style="width: 100%;"
      value-format="yyyy-MM-dd"
      placeholder="选择日期"
      @keyup.up.native="cursorUp"
      @keyup.enter.native="cursorEntry"
      @keyup.down.native="cursorDown"
    ></el-date-picker>

    <el-select
      v-else-if="editable && editConfigure.editType == 'select'"
      v-focus
      ref="selectContent"
      @change="onSelectChange"
      @focus="onSelectFocus"
      @handleOptionClick="handleOptionClick"
      filterable
      placeholder="请选择"
      v-model="selectValue"
      @keyup.up.native="cursorUp"
      @keyup.enter.native="cursorEntry"
      @keyup.down.native="cursorDown">
      <el-option  v-for="sItem in editConfigure.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>
    </el-select>

    <xr-page-select  v-else-if="editable && editConfigure.editType == 'pageSelect'" :selectName="pageSelectName" @cleanPageSelect="cleanPageSelectId()" @pageSelect="clickPageSelect()"
                     @keyup.up.native="cursorUp"
                     @keyup.enter.native="cursorEntry"
                     @keyup.down.native="cursorDown" >
      <el-input slot="page-select-name" v-model="pageSelectName" readonly v-focus  @blur="onPageSelectInputBlur"></el-input>
      <input slot="page-select-id" type="hidden" v-model="pageSelectId"></input>
    </xr-page-select>

    <el-checkbox
      v-else-if="editConfigure.editType == 'checkbox'"
      true-label="1"
      false-label="0"
      @change="onCheckboxChange"
      v-model="checkboxValue"
      @keyup.up.native="cursorUp"
      @keyup.enter.native="cursorEntry"
      @keyup.down.native="cursorDown">
<!--      <el-option  v-for="sItem in editConfigure.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>-->
    </el-checkbox>

    <el-autocomplete
      v-else-if="editable && editConfigure.editType == 'autocomplete'"
      v-focus
      @blur="onAutoCompleteBlur"
      v-model="autocompleteValue"
      style="width:100%"
      :fetch-suggestions="querySearch"
      @select="handleSelect"
      @keyup.up.native="cursorUp"
      @keyup.enter.native="cursorEntry"
      @keyup.down.native="cursorDown"></el-autocomplete >

    <sup class="cell-span-text" v-else v-html="cellView(editConfigure,rowData)"></sup>

    <page-select-dialog ref="pageSelectDialog" v-if="editable && editConfigure.editType == 'pageSelect'&&isPageSelectShow" :type="pageSelectType"  @confirmMethod="pageSelectDialogConfirm(arguments)" @cancelMethod="pageSelectDialogCancel"></page-select-dialog>


  </div>
</template>

<script>

  import PageSelectDialog from '../PageSelect/pageSelectDialog'


    export default {
        name: "editCell",
        props: {
          editConfigure: {
            type: Object,
            default: {
              field: '',
            }
          },
          rowData: {
            type: Object,
            default: {
              field: '',
            }
          },
          editUrl: {
            type: String,
            default: ''
          },
          idField: {
            type: String,
            default: ''
          },
        },
        computed: {
          fillBackColor() {
            let result = '';
            if(!!this.editConfigure && this.editConfigure.fillBackColor != null && this.editConfigure.fillBackColor != '' && this.editConfigure.fillBackColor != undefined){
              result = this.editConfigure.fillBackColor;
            }
            return result;
          }
        },
        inject:['refreshRowData', 'handleClickTableRow', 'getRowDataByIndex'],
        data() {
          return {
            editable: false,
            inputValue: '',
            autocompleteValue: '',                    //自动联想
            numberValue: undefined,                   //【数字型】  值
            dateValue: '',
            selectValue: '',
            checkboxValue: '',
            pageSelectType: '',
            focusStatus: false,
            selectSwitch: false,
            pageSelectName: '',
            pageSelectId: '',
            isPageSelectShow: false
          }
        },
        directives: {
          // 注册一个局部的自定义指令 v-focus
          focus: {
            // 指令的定义
            inserted: function (el) {
              // 聚焦元素
              el.querySelector('input').focus()
            }
          }
        },
        components: {
          PageSelectDialog
        },
        created() {
          this.initValue();
        },
        methods: {
          clickCell(){
            let index = this.rowData.index;
            this.rowData = this.getRowDataByIndex(index);
            this.initValue();
            this.handleClickTableRow(this.rowData,  'rowData');
            //判断是否可编辑
            if(this.editConfigure.cellType == 'edit'){
              this.editable = true;
            }
          },
          initValue(){
            if(this.editConfigure.editType == 'input'){
              this.inputValue = this.rowData[this.editConfigure.field];
            }else if(this.editConfigure.editType == 'autocomplete'){
              this.autocompleteValue = this.rowData[this.editConfigure.field];
            }else if(this.editConfigure.editType == 'number'){
              if(!!this.rowData[this.editConfigure.field]){
                this.numberValue = this.rowData[this.editConfigure.field];
              }
            }else if(this.editConfigure.editType == 'date'){
              this.dateValue = this.rowData[this.editConfigure.field];
            }else if(this.editConfigure.editType == 'select'){
              this.selectValue = this.rowData[this.editConfigure.field];
            }else if(this.editConfigure.editType == 'checkbox'){
              this.checkboxValue = this.rowData[this.editConfigure.field];
            }else if(this.editConfigure.editType == 'pageSelect'){
              this.pageSelectName = this.rowData[this.editConfigure.field];
              this.pageSelectId = this.rowData[this.editConfigure.pageSelectIdField];
              this.pageSelectType = this.editConfigure.pageSelectType;
            }
          },
          onInputBlur(){
            this.editable = false;
            this.update();
          },
          onAutoCompleteBlur(){
            let that = this;
            setTimeout(function(){
              that.editable = false;
              that.update();
            },100);
            // this.$refs.selectContent.$refs.reference.$refs.input.onblur = () => {
            //   setTimeout(this.closeEdit,200);
            // };
          },
          //数字型 焦点事件
          onNumberBlur(){
            this.editable = false;
          },
          onDateBlur(){
            this.editable = false;
            this.update();
          },
          //数字型 修改
          onNumberChange(currentValue, oldValue){
            this.numberValue = currentValue;
            this.update();
          },
          onSelectChange(){
            this.update();
          },
          onCheckboxChange(val){
            this.checkboxValue = val;
            this.update();
          },
          handleOptionClick(){
            this.selectSwitch = true;
          },
          onSelectFocus(){
            this.$refs.selectContent.$refs.reference.$refs.input.onblur = () => {
              setTimeout(this.closeEdit,200);
            };
          },
          closeEdit(){
            if(!this.selectSwitch){
              this.editable = false;
            }else{
              this.selectSwitch = false;
            }
          },
          update(){
            let oldValue = this.rowData[this.editConfigure.field];
            let params = new Object();
            params[this.idField] = this.rowData[this.idField];
            let newValue = "";
            if(this.editConfigure.editType == 'input'){
              this.rowData[this.editConfigure.field] = this.inputValue;
              newValue = this.inputValue;
              params[this.editConfigure.field] = newValue;
            }else if(this.editConfigure.editType == 'autocomplete'){
              this.rowData[this.editConfigure.field] = this.autocompleteValue;
              newValue = this.autocompleteValue;
              params[this.editConfigure.field] = newValue;
            }else if(this.editConfigure.editType == 'number'){
              this.rowData[this.editConfigure.field] = this.numberValue;
              newValue = this.numberValue;
              params[this.editConfigure.field] = newValue;
            }else if(this.editConfigure.editType == 'date'){
              this.rowData[this.editConfigure.field] = this.dateValue;
              newValue = this.dateValue;
              params[this.editConfigure.field] = newValue;
            }else if(this.editConfigure.editType == 'select'){
              this.rowData[this.editConfigure.field] = this.selectValue;
              newValue = this.selectValue;
              params[this.editConfigure.field] = newValue;
              if(!!this.editConfigure.selectColumnName){  //如果选择的关联名称字段不为空，则修改关联名称
                let obj = this.editConfigure.condition.selectList.find((item)=>{
                  return item.value === newValue;
                });
                if(!!obj){
                  params[this.editConfigure.selectColumnName] = obj.label;
                }
              }
            }else if(this.editConfigure.editType == 'checkbox'){
              this.rowData[this.editConfigure.field] = this.checkboxValue;
              newValue = this.checkboxValue;
              params[this.editConfigure.field] = newValue;
            }else if(this.editConfigure.editType == 'pageSelect'){
              this.rowData[this.editConfigure.field] = this.pageSelectName;
              this.rowData[this.editConfigure.pageSelectIdField] = this.pageSelectId;
              newValue = this.pageSelectId;
              params[this.editConfigure.field] = this.pageSelectName;
              params[this.editConfigure.pageSelectIdField] = newValue;
            }

            //如果值没有发生改变，则就不请求后台了
            if(oldValue === newValue){
              return false;
            }
            if(!!this.editUrl){
              return this.request({
                method:'post',
                url: this.editUrl,
                params: params
              }).then((response) =>{          //这里使用了ES6的语法
                // 请求成功返回的数据
                //如果返回编码不为0，提示失败语
                if(response.code != '0'){
                  this.$message.error(response.msg);
                  return false;
                }
                this.$emit('editDataCallback', this.editConfigure.field, newValue)

                if(response.data != ''){
                  this.rowData.caliInDate = response.data.caliInDate;
                  this.rowData.lastCheckDate = response.data.lastCheckDate;
                }

                this.refreshRowData(this.rowData);

              })
            }else {
              console.log('callback')
              this.$emit('editDataCallback', this.editConfigure.field, newValue)
            }
          },
          cellView(item,row){  //单元格显示
            if(item.formatter){
              return item.formatter(row[item.field])
            }else if(item.condition&&item.condition.searchType == 'select'){
              let viewValue = '';
              for(let i = 0 ; i < item.condition.selectList.length ; i ++){
                if(item.condition.selectList[i].value == row[item.field]){
                  viewValue = item.condition.selectList[i].label;
                }
              }
              return viewValue;
            }else{
              return row[item.field]
            }
          },
          //选择科室
          clickPageSelect(){
            this.selectSwitch = true;
            this.isPageSelectShow = true
            let firstParam = '';
            let secondParam = '';
            let thirdParam = '';
            if(!!this.editConfigure.pageSelectParam){
              let paramArr = this.editConfigure.pageSelectParam.split(',');
              if(paramArr.length > 0){
                firstParam = paramArr[0]
              }
              if(paramArr.length > 1){
                secondParam = paramArr[1]
              }
              if(paramArr.length > 2){
                thirdParam = paramArr[2]
              }
            }
            this.$nextTick(()=>{
              this.$refs.pageSelectDialog.init('' ,firstParam, secondParam, thirdParam) //初始化页面
            })
          },
          //选择org的回调事件
          pageSelectDialogConfirm(msg){
            this.isPageSelectShow = false;  //关闭
            setTimeout(this.closeEdit,200);
            this.pageSelectId = msg[0];
            this.pageSelectName = msg[1];
            this.update();
          },
          //关闭org的回调事件
          pageSelectDialogCancel(){
            setTimeout(this.closeEdit,200);
          },
          //清空
          cleanPageSelectId(){
            this.selectSwitch = true;
            this.pageSelectId = '';
            this.pageSelectName = '';
            this.update();
          },
          //pageSelect的input
          onPageSelectInputBlur(){
            setTimeout(this.closeEdit,200);
          },
          //点击键盘【下键】
          cursorDown(){
            // this.$emit('keyupMethod', 'down', this.editConfigure.field + '-' + this.rowData.index)
          },
          //点击键盘【下键】
          cursorUp(){
            // this.$emit('keyupMethod', 'up', this.editConfigure.field + '-' + this.rowData.index)
          },
          //回车键
          cursorEntry(){
            this.$emit('keyupMethod', 'down', this.editConfigure.field + '-' + this.rowData.index)
          },
          //自动匹配调用的函数
          querySearch(queryString, cb) {
            let selectList = this.editConfigure.condition.selectList;
            let results = queryString ? selectList.filter(this.createFilter(queryString)) : selectList;
            // 调用 callback 返回建议列表的数据
            cb(results);
          },
          //回调
          createFilter(queryString) {
            return (restaurant) => {
              return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
          },
          //选择触发的函数
          handleSelect(item) {
            console.log(item);
          }
        }
    }
</script>

<style scoped>
  .item-cell:after{

    content:" ";
    display:block;
    height:0;
    clear:both;
    visibility:hidden;

  }

  .item-cell{

    /*触发haslayout*/

    zoom:1;

  }
</style>



// WEBPACK FOOTER //
// src/components/XrTable/editCell.vue